export default __webpack_public_path__ + "static/logo_ELIB_BM-751284cb47eb12da99af7f7ac7fdad7e.png";